import styled from 'styled-components'

const fontFamily = `-apple-system, BlinkMacSystemFont,
    'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetical Neue', sans-serif;`

  const TextBox = styled.span`
  font-family: ${fontFamily};
  margin: 0;
  color: #9CB06D;
  font-weight: 600;
  line-height: 1.5;
  font-size: ${props => (props.size ? props.size : 'inherit')}`;

export default TextBox